import React, { useMemo, useState } from "react";
import PageHero from "../components/shared/PageHero";
import CategoryPills from "../components/shared/CategoryPills";
import FeaturedPost from "../components/blog/FeaturedPost";
import ArticleGrid from "../components/blog/ArticleGrid";
import WearCultureCta from "../components/lifestyle/WearCultureCta";
import { articles, lifestyleCategories, getArticleBySlug } from "../articlesData";

const lifestyleArticles = articles.filter((a) => a.section === "lifestyle");
const featured = getArticleBySlug("new-wave-lagos-fashion");

export default function Lifestyle() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered = useMemo(() => {
    if (activeCategory === "All") return lifestyleArticles;
    return lifestyleArticles.filter((a) => a.tag === activeCategory);
  }, [activeCategory]);

  return (
    <>
      <PageHero
        eyebrow="Beyond The Music"
        title="Fashion, Culture & Lifestyle"
        subtitle="Stories at the intersection of fashion, creativity, and modern culture — where the sound meets the style."
      />

      <section className="mu-section pb-0">
        <div className="container">
          <CategoryPills categories={lifestyleCategories} active={activeCategory} onSelect={setActiveCategory} />
        </div>
      </section>

      <FeaturedPost article={featured} />
      <ArticleGrid title="Latest Stories" articles={filtered} />
      <WearCultureCta />
    </>
  );
}
